import trophy from './trophy.svg';
import { GoalText } from './GoalText/index.js';
import styles from './styles.module.scss';

export function GoalReinforcement({ gameProfile }) {
  return (
    <div className={styles.container}>
      <img src={trophy} className={styles.trophy} />
      <div>
        <GoalText gameProfile={gameProfile} />
      </div>
    </div>
  );
}
